<div class="ssh-container" [ngClass]="{'disabled': showLoader}">
  <div class="flex flex-row items-center justify-between">
    <div>
      <div class="mat-subtitle-2 fw-600 fs-24">{{edit ? ('INSTANCE_DETAILS.EDIT_KEY' | transloco) : ('INSTANCE_DETAILS.ADD_KEY' | transloco)}}</div>
    </div>
    <div>
      <mat-icon class="justify-items-end cursor-pointer icon-lg" (click)="closeSidenav()" svgIcon="close"></mat-icon>
    </div>
  </div>
  <mat-divider class="neutral-2 mt-12 mb-12"></mat-divider>
  <form [formGroup]="encKeyForm" class="pt-8 form-section">

    <div class="flex flex-col mb-24">
      <div class="flex flex-row justify-start items-center">
        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.KEY_NAME' | transloco | uppercase }}</label>
        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.KEY_NAME' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <input [readonly]="edit" formControlName="name" placeholder="{{'INSTANCE_DETAILS.KEY_NAME' | transloco}}" class="fw-500" required>
      <app-error [control]="encKeyForm.get('name')"></app-error>
    </div>
    <div class="flex flex-col mb-24">
      <div class="flex flex-row justify-start items-center">
        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.KEY' | transloco | uppercase }}</label>
        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.KEY' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <textarea formControlName="publicKey" placeholder="{{'INSTANCE_DETAILS.PGP_KEY' | transloco}}" class="fw-500 text-area" required></textarea>
      <app-error [control]="encKeyForm.get('publicKey')"></app-error>
    </div>

    <div class="flex flex-col bp-date date">
      <div class="mat-subtitle-1 fw-700 fs-12 mb-0 flex items-center date-header">{{'INSTANCE_DETAILS.EXPIRY_DATE' | transloco | uppercase }}
        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.EXPIRY_DATE' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <div class="date-picker mt-4">
        <app-datepicker [control]="encKeyForm.get('expirationDate')" [placeholder]="'INSTANCE_DETAILS.SELECT_EXPIRY_DATE' | transloco" class="datepicker" [min]="minExpDate"></app-datepicker>
        <app-error [control]="encKeyForm.get('expirationDate')"></app-error>
      </div>
    </div>
  </form>

  <span class="flex-auto mb-10"></span>
  <mat-divider class="neutral-2 mt-16 mb-16"></mat-divider>
  <div class="footer pt-16" >
    <div class="flex flex-row justify-end gap-x-6">
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button class="accent" type="button" [disabled]="edit && !isFormChanged" [ngClass]="{ 'disabled-btn': edit && !isFormChanged }" (click)="validateForm()">{{'ADD_SOLUTION.SUBMIT' | transloco}}</button>
    </div>
  </div>
</div>

<div class="flex items-center justify-center loader" *ngIf="showLoader">
  <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
</div>
